module.exports = __webpack_public_path__ + "static/instagram-c542671000215a93a6a566c2ac97bdce.mp4";